var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: { padding: "40px 0 40px 0", "background-color": "#101010" }
    },
    [
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-row",
            { staticStyle: { padding: "0 16px" } },
            [
              _c(
                "el-col",
                {
                  staticStyle: { display: "flex", "flex-direction": "row" },
                  attrs: { span: 24 }
                },
                [
                  _c("span", { staticClass: "contact-up-p-bold" }, [
                    _vm._v("Questions?")
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    padding: "5px 16px 5px 16px"
                  },
                  attrs: { span: 24 }
                },
                [
                  _c("div", { staticClass: "email-heading" }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-family":
                            "Metropolis, -apple-system, Roboto, Helvetica,sans-serif",
                          color: "#ffbe00"
                        }
                      },
                      [_vm._v("team@unifiproperty.com")]
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-679f0df5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-679f0df5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/contactUs.vue
// module id = null
// module chunks = 